/**
 * Base URI is for assests in the Amazon s3 bucket "shoflo-assets"
 */
const baseUri = `${window.globals.shofloAssetBaseUrl}/img/`;

export default {
  onboardingArrow: `${baseUri}onboarding-arrow.svg`,
  defaulTeamPhoto: `${baseUri}no-team-photo.png`,
  defaultEventPhoto: `${baseUri}no-event-photo.png`,
  dashDropZoneFileGraphic: `${baseUri}dash-dropzone-file-graphic.svg`,
  emptyListsGraphic: `${baseUri}list-file-graphic.svg`,
  emptyShowsGraphic: `${baseUri}show-file-graphic.svg`,
  emptySchedulesGraphic: `${baseUri}schedule-file-graphic.svg`,
  emptyDocsGraphic: `${baseUri}docs-file-graphic.svg`,
  emptyTemplatesGraphic: `${baseUri}templates-file-graphic.svg`,
  emptySavedGraphic: `${baseUri}saved-file-graphic.svg`,
  scriptExportGraphic: `${baseUri}script-export-paper.svg`,
  upgradeTeleprompter: `${baseUri}teleprompter-activation.png`,
  onboardingTeleprompterArrow: `${baseUri}arrow_pointer.svg`,
  onboardingTeleprompterArrowOpposite: `${baseUri}arrow_pointer_opposite.svg`,
  displayViewModalImage: `${baseUri}displayViewModal.png`,
};
